import { Survey } from '@lib/iab/iab-vast-model';

interface ISurvey {
    type: string;
    _value: string;
}

const createSurvey = ($survey: ISurvey): Survey => {
    const survey = new Survey();
    survey.type = $survey.type;
    survey.uri = $survey._value;
    return survey;
};

export default createSurvey;
